document.addEventListener('DOMContentLoaded',()=>{
  const stockMessage='Stock épuisé pour ce produit.';
  const quantityInput=target=>target?.closest('m-cart .m-cart-item')?.querySelector('m-quantity-input input[data-vl-stock]');
  const showMessage=(input,message)=>{
    const quantity=input?.closest('m-quantity-input');
    if(!quantity)return;
    let feedback=quantity.parentElement.querySelector('.vl-cart-stock-feedback');
    if(!feedback){
      feedback=document.createElement('p');
      feedback.className='vl-cart-stock-feedback';
      feedback.setAttribute('role','alert');
      quantity.after(feedback);
    }
    feedback.textContent=message;
    feedback.hidden=false;
  };
  const clearMessage=input=>{
    const feedback=input?.closest('.m-cart-item')?.querySelector('.vl-cart-stock-feedback');
    if(feedback)feedback.hidden=true;
  };
  const exceedsStock=(input,requested)=>{
    if(!input||input.dataset.vlStockManaged!=='true')return false;
    const stock=Number.parseInt(input.dataset.vlStock,10);
    const reserved=Number.parseInt(input.dataset.cartQuantity,10);
    const current=Number.parseInt(input.getAttribute('value'),10);
    return Number.isFinite(stock)&&Number.isFinite(reserved)&&Number.isFinite(current)&&reserved-current+requested>stock;
  };
  document.addEventListener('click',event=>{
    const plus=event.target.closest('m-cart .m-cart-item m-quantity-input button[name="plus"]');
    if(!plus)return;
    const input=quantityInput(plus);
    if(!input)return;
    if(exceedsStock(input,(Number.parseInt(input.value,10)||0)+1)){
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(input,stockMessage);
    }else clearMessage(input);
  },true);
  const validateTypedQuantity=event=>{
    const input=event.target;
    if(!input.matches?.('m-cart .m-cart-item m-quantity-input input[data-vl-stock]'))return;
    const requested=Number.parseInt(input.value,10);
    if(exceedsStock(input,requested)){
      event.preventDefault();
      event.stopImmediatePropagation();
      input.value=input.getAttribute('value');
      showMessage(input,stockMessage);
    }else clearMessage(input);
  };
  document.addEventListener('input',validateTypedQuantity,true);
  document.addEventListener('change',validateTypedQuantity,true);
  customElements.whenDefined('m-cart').then(()=>{
    const prototype=customElements.get('m-cart')?.prototype;
    if(!prototype||prototype.vlStockFeedbackInstalled)return;
    const original=prototype.updateLiveRegions;
    prototype.updateLiveRegions=function(line,error){
      const input=this.querySelector(`#MinimogQuantity-${line}`);
      if(error&&input)showMessage(input,stockMessage);
      else if(input)clearMessage(input);
      return original.call(this,line,error);
    };
    prototype.vlStockFeedbackInstalled=true;
  });
});
